export const cropConfig = {
  profile: {
    aspect: 1,
    circular: true,
    minDimension: 150,
  },
  banner: {
    aspect: 3 / 1, // ou 16 / 9
    circular: false,
    minDimension: 300,
  },
};